import React from 'react';
import { Frame } from '../../_molecules/Frame';
import { AudioListWrap } from '../../_organisms/AudioListWrap';
import { AudioPlayerWrap } from '../../_organisms/AudioPlayerWrap';

export const AudioTrackTemplate = () => {
  return (
    <Frame type='audio'>
      <AudioListWrap page={true}/>
      <AudioPlayerWrap page={true}/>
    </Frame>
  );
};